import axiosInstance from "services/AxiosInstance";
import { TFeatureFlagListResponse } from "types";

export const getAccountFeatureFlagListService = async (accountId: string): Promise<TFeatureFlagListResponse> => {
  const response = await axiosInstance.get(`featureflags/${accountId}`);
  return response.data;
};
